var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Radio, Label, Chip } from './styles';
const Container = (_a) => {
    var { register, children, 'data-qa-anchor': dataQaAnchor = '' } = _a, props = __rest(_a, ["register", "children", 'data-qa-anchor']);
    return (React.createElement(Label, { "data-qa-anchor": `${dataQaAnchor}-label` },
        React.createElement(Radio, Object.assign({}, props, { ref: register, "data-qa-anchor": `${dataQaAnchor}-radio` })),
        children));
};
const Radios = ({ register, uniq = 'value', name = '', value = null, items = [], disabled = false, onChange = () => { }, }) => {
    const handleChange = (e) => {
        try {
            const newVal = JSON.parse(e.target.value);
            onChange(newVal);
        }
        catch (err) {
            onChange(e.target.value);
        }
    };
    const Renderer = ({ item, checked, disabled: d }) => {
        const props = Object.assign(Object.assign({}, item), { checked, disabled: d });
        const style = { gridArea: 'label' };
        const ItemRenderer = item.customRenderer;
        return (React.createElement(React.Fragment, null,
            ItemRenderer ? (React.createElement(ItemRenderer, Object.assign({}, props, { style: style }))) : (React.createElement("span", { style: style }, item.label)),
            React.createElement(Chip, { checked: checked })));
    };
    return items.map((item) => (React.createElement(Container, { key: item[uniq], register: register, name: name, value: item.value, checked: value === item.value, disabled: disabled, "data-qa-anchor": item['data-qa-anchor'], onChange: handleChange },
        React.createElement(Renderer, { item: item, checked: value === item.value, disabled: disabled }))));
};
export default Radios;
//# sourceMappingURL=index.js.map